let EmailManagement = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.editForm();
        this.hideDateFields();
        this.editFormFieldsVisibility();

        $('select[name=type]').change();
    },

    editForm: function () {
        let _this = this;

        let emailSettingsForm = $('.email-settings-form');
        let submitBtn = Ladda.create(emailSettingsForm.find('[type=submit]')[0]);

        emailSettingsForm.ajaxForm({
            beforeSubmit: function () {
                submitBtn.start();
            },
            success: function (response) {
                submitBtn.stop();
                if (response.success) {
                    toastr.success('Settings successfully saved!');
                } else {
                    toastr.error(response.message);
                }
            },
            error: function () {
                submitBtn.stop();
            }
        });
    },

    editFormFieldsVisibility: function () {
        let _this = this;

        $('select[name=type]').on('change', function () {
            _this.hideDateFields();
            switch ($(this).val()) {
                case 'daily':
                    break;
                case 'weekly':
                    $(this).closest('form').find('select[name=day_of_week]').closest('div').show();
                    break;
                case 'monthly':
                    $(this).closest('form').find('select[name=day_of_month]').closest('div').show();
                    break;
            }
        });
    },

    hideDateFields: function () {
        $('select[name=day_of_week]').closest('div').hide();
        $('select[name=day_of_month]').closest('div').hide();
    }
};

$().ready(function () {
    window.EmailManagement = EmailManagement;
    window.EmailManagement.init();
});